import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import Layout from './components/Layout';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import MasterMatrixPage from './pages/MasterMatrixPage';
import LandingPage from './pages/LandingPage';
import CanvasPage from './pages/CanvasPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />

        {/* Protected Routes */}
        <Route
          path="/projects"
          element={<ProtectedRoute><Layout><ProjectsPage /></Layout></ProtectedRoute>}
        />
        <Route
          path="/master-matrix"
          element={<ProtectedRoute><Layout><MasterMatrixPage /></Layout></ProtectedRoute>}
        />
        <Route
          path="/projects/:projectId"
          element={<ProtectedRoute><Layout><ProjectDetailsPage /></Layout></ProtectedRoute>}
        />
        <Route path="/projects/:projectId/canvas" element={<ProtectedRoute><CanvasPage /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
